import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { CountdownRing } from '../CountdownRing';
export function BigIdeaSlide() {
  const reduced = useReducedMotion();
  return <SlideFrame eyebrow="The big idea" index={1} showMiniCountdown={false} data-id="element-59" data-mp="2hp4r0b1uqcrh">
      <div className="grid grid-cols-[1.15fr_0.85fr] items-center gap-[5%]" data-id="element-60" data-mp="2lp52pnxkg9uu">
        <div data-id="element-61" data-mp="1p0gz3wmlkp4y">
          <p className="text-[clamp(9px,0.9vw,16px)] uppercase tracking-[0.36em] text-[color:var(--sv-green)]" data-id="element-62" data-mp="1p0pf3xe0oakd">
            Engagement platform
          </p>
          <h1 className="mt-[2.5vh] text-[clamp(34px,5.2vw,92px)] font-semibold leading-[1.02] tracking-tight text-white" data-id="element-63" data-mp="1u0v7xgw0w341">
            Time with Solventum
            <br data-id="element-64" data-mp="230i0dd6rxyky" />
            <span className="text-[color:var(--sv-green)]" data-id="element-65" data-mp="231056y7i5l4h">pays back.</span>
          </h1>
          <p className="mt-[3vh] max-w-[36ch] text-[clamp(13px,1.5vw,28px)] font-light leading-snug text-white/60" data-id="element-66" data-mp="39f95jt2xk5ks">
            A recognizable low-effort, high-reward engagement format for
            Solventum Dental.
          </p>
        </div>

        <motion.div className="flex justify-center" initial={reduced ? false : {
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-67" data-mp="34byhupd33zbn">
          <CountdownRing data-id="element-68" data-mp="2ucpq835oywsg" />
        </motion.div>
      </div>
    </SlideFrame>;
}